import * as React from 'react';
import * as _ from 'lodash';
import { ViewCategoryContainer, ViewCategorySection, ViewCategorySubtitle, ViewCategoryList, ViewCategoryLabel } from './styles';
import { DealerEngineCategories } from 'features/Dealers/Listings/Categories/state/types';


export interface ViewUICategoriesProps {
    categories: DealerEngineCategories
}


const ViewUICategories = (props: ViewUICategoriesProps) => {
    return (
        <ViewCategoryContainer>
            <ViewCategorySection>
                <ViewCategorySubtitle>
                    {
                        "Primary Category"
                    }
                </ViewCategorySubtitle>
                <ViewCategoryLabel>
                    {
                        props.categories.primaryCategory.name
                    }
                </ViewCategoryLabel>
            </ViewCategorySection>
            <ViewCategorySection>
                <ViewCategorySubtitle>
                    {
                        "Additional Categories"
                    }
                </ViewCategorySubtitle>
                <ViewCategoryList>
                    {
                        props.categories.additionalCategories.map(c => {
                            return (
                                <ViewCategoryLabel key={c.id}>
                                    {
                                        c.name
                                    }
                                </ViewCategoryLabel>
                            )
                        })
                    }
                </ViewCategoryList>
            </ViewCategorySection>
        </ViewCategoryContainer>
    )
}

export default ViewUICategories